import * as yup from 'yup';

const uploadNewsfeedValidationSchema = yup.object({
  caption: yup
    .string()
    .required()
    .label('Caption')
    .test(
      'length-limit',
      'Caption must have upto 700 characters',
      (value) => (value?.replace(/[\r\n]+/gm, '')?.length || 0) <= 700,
    ),
  mediaUrl: yup.string().trim(),
  visibility: yup.string().trim().required('Visibility is a required field'),
}).required();

export default uploadNewsfeedValidationSchema;
